import { Injectable } from "@angular/core";
import { DwAction, DwGridActionConfig, DwGridActionKeys, DwActionType, DwButtonType, DwActionHandler, DwMetaDataGridNavigationService, DwMetaDataGridActionState, DwActionResult } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AppMetaDataItemNames } from "../../../../meta-data/app-meta-data.service";
import { FinancialsRepositoryService } from "../../services/financials-repository.service";
import { ReportsRepositoryService } from "../../../reports/services/reports-repository.service";

@DwAction<DwGridActionConfig>({
    keyName: 'grid-return-to-financials',
    display: 'Return to Charts',
    actionType: DwActionType.gridAction,
    isGlobal: true,
    //parentItemName: AppMetaDataItemNames.CheckRideRequest,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonText: '',
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-chart-bar',
        command: 'return',
        buttonType: DwButtonType.standard,
        
    },
})
@Injectable()
export class GridReturnToFinancialsActionService implements DwActionHandler {

    constructor(private metaDataGridNavigationService: DwMetaDataGridNavigationService,
        private financialsRepositoryService: FinancialsRepositoryService,
        private reportsRepositoryService: ReportsRepositoryService
        
        ) { }

    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {

        // Close both areas so we don't have create a new action
        this.financialsRepositoryService.closeGrid();
        this.reportsRepositoryService.closeGrid();

        return of({
            success: true,
        });
    }
}
